import React, { useRef, useState, useContext, useEffect } from 'react'
import { Field, FieldArray, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { getImages } from '../../../const'
import RangeSlider from "react-range-slider-input";
import "react-range-slider-input/dist/style.css";
import { TripContext } from '../../Context/TripContext';

const TripStatsModal = ({ close, handleImageChange,setImageSrc, setShowCrop, selectedImages, setSelectedImages }) => {
    const formikRef = useRef(null);
    const [value, setValue] = useState([0, 50]);
    const { tripData } = useContext(TripContext);
    const [directions, setDirections] = useState(null);
    const isRealTrip = tripData && tripData.origin && tripData.park_list && tripData.park_list.length > 0;

    useEffect(() => {
        if (tripData && 'origin' in tripData && 'park_list' in tripData && tripData.park_list.length > 0) {
            const directionsService = new window.google.maps.DirectionsService();
            const dest = tripData.park_list.slice(-1)[0];
            const intermediateStops = tripData.park_list.slice(0, -1).map(v => ({ location: v, stopover: true }));
            
            const routeData = {
                origin: tripData.origin,
                destination: dest,
                waypoints: intermediateStops,
                travelMode: window.google.maps.TravelMode.DRIVING,
                avoidHighways: true
            };

            directionsService.route(routeData, (result, status) => {
                if (status === "OK") {
                    setDirections(result);
                }
            });
        }
    }, [tripData]);

    let totalDistanceMiles = 0;
    let pathData = "";
    let stopsData = [];

    if (directions && directions.routes.length > 0) {
        const route = directions.routes[0];
        const overviewPath = route.overview_path;
        
        let minLat = 90, maxLat = -90, minLng = 180, maxLng = -180;
        overviewPath.forEach(p => {
            const lat = typeof p.lat === 'function' ? p.lat() : p.lat;
            const lng = typeof p.lng === 'function' ? p.lng() : p.lng;
            if (lat < minLat) minLat = lat;
            if (lat > maxLat) maxLat = lat;
            if (lng < minLng) minLng = lng;
            if (lng > maxLng) maxLng = lng;
        });

        const latDiff = maxLat - minLat || 0.01;
        const lngDiff = maxLng - minLng || 0.01;
        
        const paddedMinLat = minLat - latDiff * 0.15;
        const paddedMaxLat = maxLat + latDiff * 0.15;
        const paddedMinLng = minLng - lngDiff * 0.15;
        const paddedMaxLng = maxLng + lngDiff * 0.15;

        const pLatDiff = paddedMaxLat - paddedMinLat;
        const pLngDiff = paddedMaxLng - paddedMinLng;

        const generateX = (lng) => ((lng - paddedMinLng) / pLngDiff) * 200;
        const generateY = (lat) => ((paddedMaxLat - lat) / pLatDiff) * 200;

        pathData = overviewPath.reduce((acc, p, i) => {
            const lat = typeof p.lat === 'function' ? p.lat() : p.lat;
            const lng = typeof p.lng === 'function' ? p.lng() : p.lng;
            const x = generateX(lng);
            const y = generateY(lat);
            return acc + (i === 0 ? `M ${x} ${y} ` : `L ${x} ${y} `);
        }, "");

        route.legs.forEach(leg => {
            totalDistanceMiles += leg.distance.value;
        });
        totalDistanceMiles = Math.round(totalDistanceMiles * 0.000621371);

        stopsData.push({ 
            x: generateX(typeof route.legs[0].start_location.lng === 'function' ? route.legs[0].start_location.lng() : route.legs[0].start_location.lng), 
            y: generateY(typeof route.legs[0].start_location.lat === 'function' ? route.legs[0].start_location.lat() : route.legs[0].start_location.lat) 
        });
        route.legs.forEach(leg => {
            stopsData.push({ 
                x: generateX(typeof leg.end_location.lng === 'function' ? leg.end_location.lng() : leg.end_location.lng), 
                y: generateY(typeof leg.end_location.lat === 'function' ? leg.end_location.lat() : leg.end_location.lat) 
            });
        });

        // Anti-overlap for markers
        const MIN_DIST = 26;
        for (let iter = 0; iter < 100; iter++) {
            let moved = false;
            for (let i = 0; i < stopsData.length; i++) {
                for (let j = i + 1; j < stopsData.length; j++) {
                    let dx = stopsData[i].x - stopsData[j].x;
                    let dy = stopsData[i].y - stopsData[j].y;
                    let dist = Math.sqrt(dx * dx + dy * dy);
                    if (dist < MIN_DIST) {
                        moved = true;
                        if (dist === 0) {
                            stopsData[i].x += 1;
                            stopsData[j].x -= 1;
                        } else {
                            let pushDist = (MIN_DIST - dist) / 2 + 0.5;
                            let pushX = (dx / dist) * pushDist;
                            let pushY = (dy / dist) * pushDist;
                            stopsData[i].x += pushX;
                            stopsData[i].y += pushY;
                            stopsData[j].x -= pushX;
                            stopsData[j].y -= pushY;
                        }
                    }
                }
            }
            if (!moved) break;
        }
    }

    const allPlaces = tripData && tripData.origin ? [tripData.origin, ...(tripData.park_list || [])] : [];

    const handleDrop = (event, setFieldValue) => {
        event.preventDefault();

        const files = Array.from(event.dataTransfer.files);

        if (files.length > 0) {
            const file = files[0]; // first file for crop
            const imageUrl = URL.createObjectURL(file);

            setImageSrc(imageUrl);   // send to crop
            setShowCrop(true);       // open crop modal
        }

        const newImages = files.map(file => URL.createObjectURL(file));
        setSelectedImages(prevImages => [...prevImages, ...newImages]);

        uploadFiles(files);
    };

    const uploadFiles = (files) => {
        Array.from(files).map((v, i) => {
            uploadFile(v);
        });
    }

    const uploadFile = (file) => {
        console.log(file);

        // if (file) {

        //     const formData = new FormData();
        //     formData.append('file', file);
        //     formData.append('folder', 'userappraisals/');
        //     formData.append('fileName', file.name);
        //     //formData.append('base_url',true);

        //     const upload = uploadDocument(formData);
        //     upload.then((data) => {
        //         if (data.url && data.data && data.data.key) {
        //             //sendChat("",activeChatUser,data.data.key,data.url);

        //             formikRef.current.setFieldValue("photos", [...formikRef.current.values.photos, data.url]);

        //             console.log(formikRef.current.values);



        //         } else if (data.error) alert(data.error);
        //     });
        // }

    }
    const initialValues = {
        full_name: '',
        email: '',
        phone: '',
        mileage: '',
        comments: '',
        photos: []
    };


    return (
        <>
            <div className="modal-content trip-stats-block">
                {/* <div className="modal-header">
                <h1 className='modal-title filter-modal-title eurostile text-uppercase text-center w-100 font-1-2em'>Book Appointment</h1>
                </div> */}
                <div className="modal-body">
                    <button className="sm-box-close" type="button" onClick={close}>
                        <img src={getImages('m-modal-x.svg')} />
                    </button>

                    <Formik
                        initialValues={initialValues}
                        // validationSchema={step === 1 ? validationSchemaStep1 : validationSchemaStep2}
                        innerRef={formikRef}
                        onSubmit={async (values, { resetForm }) => {
                            // const token = await recaptchaRef.current.executeAsync();
                            // recaptchaRef.current.reset(); // Reset after use

                            // values = { ...values, vehicle: selectedValue, token: token };
                            // console.log(values);

                            // const data = await submitContactForm(values);

                            // if (data.success) {
                            //     resetForm();
                            //     navigate("/thank-you");
                            //     // alert("Thank you for your submission. We'll be in touch soon!");
                            //     close();
                            // } else
                            //     alert("There was a problem with your submission");
                            console.log("values", values);
                        }}
                    >
                        {({ values, validateForm, setTouched, setFieldValue }) => (
                            <Form className="custom-form get-quote-form" autoComplete="off">
                                {/* <ReCAPTCHA
                                    ref={recaptchaRef}
                                    sitekey="6Ld25IorAAAAANZCaPfhdftOf511aOBscsnhKulz" // Replace with your actual site key
                                    size="invisible"
                                /> */}
                                <div className='tsb-flex d-flex mt-md-4'>
                                    <div className='tsb-left'>
                                        <div className='tsb-mob-box'>
                                            <img
                                                src={
                                                    Array.isArray(selectedImages) && selectedImages.length > 0
                                                    ? selectedImages[0]
                                                    : getImages('bg-mobile.png')
                                                }
                                            />
                                            <div className='tsbm-pos'>
                                                <div className='mb-2 d-flex align-items-center'>
                                                    <div className='tsbm-icon'><img src={getImages('pyramid.png')} /></div>
                                                    <div><img src={getImages('we-go-scenic.png')} /></div>
                                                </div>
                                                <div className='tsb-line-path mb-4' style={{ width: '100%', minHeight: '200px', display: 'flex', justifyContent: 'center', marginTop: '-15px', alignItems: 'center' }}>
                                                    {directions ? (
                                                        <svg viewBox="-20 -20 240 240" width="100%" height="200" style={{ maxWidth: '200px' }}>
                                                            <path d={pathData} fill="none" stroke="#dedede" strokeWidth="3" opacity="0.6" strokeLinecap="round" strokeLinejoin="round" />
                                                            <path d={pathData} fill="none" stroke="#fa835f" strokeWidth="3" pathLength="100" strokeDasharray="100" strokeDashoffset={100 - value[1]} strokeLinecap="round" strokeLinejoin="round" />
                                                            {stopsData.map((pt, i) => {
                                                                if (i === 0) {
                                                                    return (
                                                                        <g key={i} transform={`translate(${pt.x}, ${pt.y})`}>
                                                                            <image href={getImages('start.png')} x="-16" y="-16" width="32" height="32" />
                                                                        </g>
                                                                    );
                                                                }
                                                                return (
                                                                    <g key={i} transform={`translate(${pt.x}, ${pt.y})`}>
                                                                        <circle cx="0" cy="0" r="10" fill={value[1] >= (i / Math.max(1, stopsData.length - 1)) * 100 ? "#fa835f" : "#dedede"} stroke="#dedede" strokeWidth="1" />
                                                                        <text x="0" y="3" fontSize="10" fill="#fff" textAnchor="middle" fontWeight="bold">{i}</text>
                                                                    </g>
                                                                );
                                                            })}
                                                        </svg>
                                                    ) : isRealTrip ? (
                                                        <div className="spinner-border" style={{ color: '#fa835f' }} role="status">
                                                            <span className="visually-hidden">Loading...</span>
                                                        </div>
                                                    ) : (
                                                        <img src={getImages('line_path.png')} />
                                                    )}
                                                </div>
                                                <div className='px-3'>
                                                    <div className='d-flex justify-content-between'>
                                                        <div className='text-center'>
                                                            <div className='tsb-lg-title'>{directions ? totalDistanceMiles : (isRealTrip ? '...' : 682)} <span className="unit">mi</span></div>
                                                            <div className='xs-title font-18 fw-400 pe-2'>Distance</div>
                                                        </div>
                                                        <div className='text-center'>
                                                            <div className='tsb-lg-title'>{value[1]}%</div>
                                                            <div className='xs-title font-18 fw-400'>Trip Completion</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='tsbm-bottom-pos'>
                                                {(tripData?.park_list || []).length > 0 ? tripData.park_list.map((place, index) => {
                                                    const isCompleted = value[1] >= ((index + 1) / Math.max(1, tripData.park_list.length)) * 100;
                                                    return (
                                                        <div className='d-flex align-items-center mb-2' key={index}>
                                                            <div className={`tbi-circle-overlay me-2 ${isCompleted ? 'completed' : ''}`}>
                                                                <div className='tbi-circle' style={{ backgroundColor: isCompleted ? '#fa835f' : '' }}>{index + 1}</div>
                                                            </div>
                                                            <div className='xxs-title opacity-1'>{place}</div>
                                                        </div>
                                                    );
                                                }) : (
                                                    <>
                                                        <div className='d-flex align-items-center mb-2'>
                                                            <div className='tbi-circle-overlay me-2'>
                                                                <div className='tbi-circle'>1</div>
                                                            </div>
                                                            <div className='xxs-title opacity-1'>Joshua Tree National Park, CA</div>
                                                        </div>
                                                        <div className='d-flex align-items-center mb-2'>
                                                            <div className='tbi-circle-overlay me-2'>
                                                                <div className='tbi-circle'>2</div>
                                                            </div>
                                                            <div className='xxs-title opacity-1'>Yosemite National Park, CA</div>
                                                        </div>
                                                        <div className='d-flex align-items-center mb-2'>
                                                            <div className='tbi-circle-overlay me-2'>
                                                                <div className='tbi-circle'>3</div>
                                                            </div>
                                                            <div className='xxs-title opacity-1'>Yellowstone National Park, WY</div>
                                                        </div>
                                                        <div className='d-flex align-items-center mb-2'>
                                                            <div className='tbi-circle-overlay me-2'>
                                                                <div className='tbi-circle'>4</div>
                                                            </div>
                                                            <div className='xxs-title opacity-1'>Zion National Park, UT</div>
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className='tsb-right'>
                                        <div className='lgray-box mb-4'>
                                            <div className='d-flex justify-content-between mb-3'>
                                                <div className='md-title'>Trip Completion</div>
                                                <div className='tc-box md-title font-20'>{value[1]}%</div>
                                            </div>
                                            <div style={{ width: "100%" }}>
                                                <RangeSlider
                                                    className="single-thumb"
                                                    defaultValue={value}
                                                    thumbsDisabled={[true, false]}
                                                    rangeSlideDisabled={true}
                                                    onInput={setValue}
                                                />
                                            </div>
                                            <div className='d-flex align-items-center justify-content-between mt-2'>
                                                <div className='small-title'>0%</div>
                                                <div className='small-title'>100%</div>
                                            </div>
                                        </div>
                                        <div className='lgray-box mb-4'>
                                            <div className='md-title mb-3'>Upload Photos</div>
                                            <div className='text-center tsb-white-box'
                                                onDragOver={(e) => e.preventDefault()}
                                                onDrop={(event) => handleDrop(event, setFieldValue)}
                                            >
                                                <div className="d-inline-flex align-items-center justify-content-between mb-2">
                                                    {selectedImages.length > 0 ?
                                                        <div className="cs-label">You Have uploaded <span className='text-danger'>{selectedImages.length}</span> photos</div> :
                                                        <div>
                                                            <div className='mb-1'>
                                                                <img src={getImages('cloud-upload-icon.png')} />
                                                            </div>
                                                            <div className="cs-label font-13 mb-2">Drop Photo Here or</div>
                                                        </div>
                                                    }
                                                </div>
                                                <div>
                                                    <input
                                                        id="fileUpload"
                                                        type="file"
                                                        accept="image/*"
                                                        multiple
                                                        hidden
                                                        onChange={(event) => handleImageChange(event, setFieldValue)}
                                                    />
                                                    <label htmlFor="fileUpload" className="custom-file-upload btn common-btn ps-4 pe-5 py-0 btn-blue-bg d-inline-flex align-items-center">
                                                        <span><img src={getImages('file-upload.png')} /></span>
                                                        <div className='xss-title text-white'>Browse Photos</div>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='d-flex align-items-center mb-3'>
                                            <div className='il-insta-logo'>
                                                <img src={getImages('integration-logos.svg')} />
                                            </div>
                                            <div className='sm-title'>Share your trip on Instagram</div>
                                        </div>
                                        <div className='tsb-xs-title mb-5'>Share your trip stats with friends via instagram stories or posts. You can download the image and lorem ipsum semper duet. Start sharing now!</div>
                                        <button className="btn common-btn px-5 d-flex align-items-center lg-btn" type="button">
                                            <span className="icon-social-instagram font-18 me-2 fw-700"></span>
                                            <div className="xs-title text-black">Share Trip Stats</div>
                                        </button>
                                    </div>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </>
    )
}

export default TripStatsModal